export default __webpack_public_path__ + "static/media/3233 spice rack A top.cc1061d6.png";